export const projects = [
    {
      id: 1,
      title: "CuroSync (Mini-Project)",
      description:
        "Health Application for timely care & telemedicine, supporting all platforms (Android, iOS, Windows, Linux, MacOS, Desktop, and Mobile).",
      techStack: ["Flutter", "Firebase Auth", "Firebase Firestore", "Supabase Storage"],
      image: "images/logos/karthiNexGen.jpg",
      liveLink: "https://curosync-app.web.app",
    },
    {
      id: 2,
      title: "Track My Grade",
      description:
        "An Android app for students & faculties to calculate CGPA, upload mark sheets, and visualize progress. Published on Play Store.",
      techStack: ["Java", "XML"],
      image: "images/logos/karthiNexGen.jpg",
      liveLink: "https://play.google.com/store/apps/details?id=com.student_developer.track_my_grade",
    },
    {
      id: 3,
      title: "CashSify (Earning App)",
      description:
        "Android application that allows students to earn by watching ads. Currently under review in the Play Console.",
      techStack: ["Java", "XML"],
      image: "images/logos/karthiNexGen.jpg",
    },
    {
      id: 4,
      title: "SAIL Health Portal",
      description:
        "A web application for managing employee medical reports at Steel Authority of India Limited (SAIL).",
      techStack: ["React.js", "Bootstrap", "Material UI", "Express.js", "Firebase", "Supabase"],
      image: "images/logos/karthiNexGen.jpg",
      liveLink: "https://ehms-sail.web.app",
    },
    {
      id: 5,
      title: "AI Text to Voice Converter",
      description:
        "A simple web app that converts text into speech, supporting long paragraphs.",
      techStack: ["HTML", "CSS", "JavaScript", "Firebase"],
      image: "images/logos/karthiNexGen.jpg",
      liveLink: "https://ks-webpage.neocities.org/text-speech/",
    },
    {
      id: 6,
      title: "College Admission Webpage",
      description:
        "A webpage for students to apply for college admissions. Built as part of a learning project.",
      techStack: ["HTML", "CSS", "JavaScript", "Firebase"],
      image: "images/logos/karthiNexGen.jpg",
      liveLink: "https://ks-webpage.neocities.org/admission/",
    },
    // {
    //   id: 7,
    //   title: "Admin Panel (CashSify)",
    //   description:
    //     "Admin application to manage users, payments, and earnings of the CashSify app.",
    //   techStack: ["Java", "XML"],
    //   image: "/src/assets/icons/admin-panel.png",
    //   githubLink: "https://github.com/karthi-AI-hub",
    // },
  ];
    

  export const certificates = [
    {
      id: 1,
      title: "Google Cloud Certification",
      image: "images/logos/karthiNexGen.jpg",
    },
    {
      id: 2,
      title: "Microsoft Azure Fundamentals",
      image: "images/logos/karthiNexGen.jpg",
    },
    {
      id: 3,
      title: "Coursera Machine Learning",
      image: "images/logos/karthiNexGen.jpg",
    },
    // Add more certificates...
  ];